import { Alert, Grid, Typography } from '@mui/material'
import type { FC } from 'react'

import PageContainer from '@/components/UI/PageContainer'

const UnauthorisedPage: FC = () => (
  <PageContainer
    pageContent={
      <Grid
        container
        sx={{ height: '100vh', alignItems: 'center', justifyContent: 'center' }}
      >
        <Alert severity="warning">
          <Typography component="p">
            You do not have permission to access this page.
          </Typography>
        </Alert>
      </Grid>
    }
  />
)

export default UnauthorisedPage
